import { IonItemDivider, IonLabel } from "@ionic/react";
import { useSelector } from "react-redux";

import { Template } from "../../../@types/template";
import { selectULTemplateList } from "../../../store/templateList/selectors/selectULTemplateList";
import { FileTemplateListItem } from "./FileTemplateListItem";


export const FileTemplateListContainer = () => {
  const ulTemplateList = useSelector(selectULTemplateList);
  return (
    <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{ulTemplateList.length} resultados</p>
        </IonLabel>
      </IonItemDivider>
      {ulTemplateList.map((template: Template) => (
        <FileTemplateListItem key={template.id} template={template} />
      ))}
    </>
  );
};
